import { render, staticRenderFns } from "./ScholarshipEdit.vue?vue&type=template&id=243d98d6"
import script from "./ScholarshipEdit.vue?vue&type=script&lang=js"
export * from "./ScholarshipEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports